import {
  defFetchList,
  defFetchOne,
  defUpdateOne,
  defCreate
} from '@/api/default'

const BASE_PATH = '/soa/receipt'

export function fetchList (query) {
  return defFetchList(BASE_PATH, query)
}

export function fetchBranchList (query) {
  return defFetchList(BASE_PATH + '/branch', query)
}

export function fetchDocList (query) {
  return defFetchList(BASE_PATH + '/doc', query)
}

export function fetchOne (id) {
  return defFetchOne(BASE_PATH, id)
}

export function updateOne (id, data) {
  return defUpdateOne(BASE_PATH, id, data)
}

export function create (data) {
  return defCreate(BASE_PATH, data)
}
